import { Component, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { PagesService } from 'src/app/pages/services/pages.service';
import { ApproveRejectService } from '../service/approve-reject.service';

@Component({
	selector: 'app-epp-signups',
	templateUrl: './epp-signups.page.html',
	styleUrls: ['./epp-signups.page.scss'],
})
export class EppSignupsPage implements OnInit {
	showHeaderFilter = true;
	companyList: any = [];
	companyList$: Observable<any> = this.approveRejectService.fetchCompanyData();
	currentListStatus: any = 'pending';

	currentPagePermission = 'company-epp-signups';

	constructor(
		private approveRejectService: ApproveRejectService,
		private alertController: AlertController,
		private toastController: ToastController,
		public pagesService: PagesService,
	) {
		this.pagesService.notValidPermissionByName(
			this.currentPagePermission,
			'/app/company',
		);
	}

	ngOnInit() {
		this.approveRejectService.loadCompanyApi().subscribe();
		this.approveRejectService.loadCompanyDataApi().subscribe();
		this.companyList$.subscribe(data => {
			this.companyList = data;
		});
	}

	handleChange(ev: any) {
		this.currentListStatus = ev.target.value;
		this.approveRejectService.loadCompanyDataApi(ev.target.value).subscribe();
	}

	updateCompanyStatus(companyId: any, status: any) {
		this.approveRejectService
			.updateCompanyNgrx(companyId, status, this.currentListStatus)
			.subscribe();
	}
}
